import React from 'react';
import PropTypes from 'prop-types';
import { TRACK_STATE_DIFFICULTY, TRACK_STATE_STATUS } from "../../../config/constants";
import { translate } from "../../../lang/trans";

const LegendTypeSwitch = ({ activeState, onChangeState }) => (
   <div className="legend-type-switch">
      <button
         className={`legend-type-switch__button ${activeState === TRACK_STATE_STATUS && 'legend-type-switch__button--active'}`}
         onClick={() => onChangeState(TRACK_STATE_STATUS)}
      >
         {translate('статус')}
      </button>

      <button
         className={`legend-type-switch__button ${activeState === TRACK_STATE_DIFFICULTY && 'legend-type-switch__button--active'}`}
         onClick={() => onChangeState(TRACK_STATE_DIFFICULTY)}
      >
         {translate('карта')}
      </button>
   </div>
);

LegendTypeSwitch.defaultProps = {
   activeState: TRACK_STATE_STATUS
};

LegendTypeSwitch.propTypes = {
   activeState: PropTypes.string.isRequired,
   onChangeState: PropTypes.func
};

export default LegendTypeSwitch;
